import Alpine from 'alpinejs'
import header from '@/components/header.js'
import language from '@/components/language.js'
import video from '@/components/video.js'
import accordion from '@/components/accordion.js'
import embedVideo from '@/components/embed/video.js'
import carousel from '@/components/carousel.js'
import hero from '@/components/hero.js'
import heroSlide from '@/components/heroSlide.js'
import range from '@/components/range.js'
import filter from '@/components/filter.js'
import events from '@/components/events.js'
import productions from '@/components/productions.js'
import contacts from '@/components/contacts.js'
import search from '@/components/search.js'
import archive from '@/components/archive.js'
import photoGallery from '@/components/photo-gallery.js'
import scrollbar from '@/components/scrollbar.js'
import productionSlide from '@/components/productionSlide.js'

//
// Styles
//
import '../css/style.css'

//
// Setup Alpine
//
window.Alpine = Alpine

//
// Globla store
//
Alpine.store('theme', document.getElementById('theme')?.dataset.theme)
Alpine.store('searchIsOpen', false)

//
// Setup Alpine components
//
Alpine.data('header', header)
Alpine.data('language', language)
Alpine.data('video', video)
Alpine.data('accordion', accordion)
Alpine.data('embedVideo', embedVideo)
Alpine.data('carousel', carousel)
Alpine.data('hero', hero)
Alpine.data('heroSlide', heroSlide)
Alpine.data('range', range)
Alpine.data('filter', filter)
Alpine.data('events', events)
Alpine.data('productions', productions)
Alpine.data('contacts', contacts)
Alpine.data('search', search)
Alpine.data('archive', archive)
Alpine.data('photoGallery', photoGallery)
Alpine.data('scrollbar', scrollbar)
Alpine.data('productionSlide', productionSlide)

//
// Initialize Alpine
//
Alpine.start()

//
// Staggered appear animations
//
const staggers = [...document.querySelectorAll('[data-stagger]')]
const triggered = new WeakSet()
const onIntersecting = (target) => {
    const items = [...target.querySelectorAll('[data-appear]')]

    if (triggered.has(target)) {
        return
    }

    triggered.add(target)

    items.forEach((item, index) => {
        const className = item.dataset.appear
        const delay = (parseInt(item.dataset.appearDelay) || 0) + index * 100
        const onAnimationEnd = (event) => {
            event.target.classList.remove(className)
            event.target.removeAttribute('data-appear')
            event.target.removeEventListener('animationend', onAnimationEnd)
        }

        item.addEventListener('animationend', onAnimationEnd)
        item.style.animationDelay = `${delay}ms`
        item.classList.add(className)
    })
}
const observer = !!window.IntersectionObserver
    ? new IntersectionObserver(
          (entries, observer) => {
              for (const entry of entries) {
                  if (entry.intersectionRatio > 0) {
                      onIntersecting(entry.target)
                      observer.unobserve(entry.target)
                  }
              }
          },
          {
              rootMargin: '0% 0% -20% 0%',
              threshold: 0,
          }
      )
    : null
const endObserver = !!window.IntersectionObserver
    ? new IntersectionObserver(
          (entries, observer) => {
              for (const entry of entries) {
                  if (entry.intersectionRatio > 0) {
                      staggers.forEach(onIntersecting)
                      observer.unobserve(entry.target)
                  }
              }
          },
          {
              rootMargin: '0%',
              threshold: 0,
          }
      )
    : null

staggers.forEach((stagger) => {
    if (observer) {
        observer.observe(stagger)
    } else {
        onIntersecting(stagger)
    }
})

if (endObserver) {
    endObserver.observe(document.querySelector('#scroll-end-trigger'))
}
